import styled from "styled-components";

// tslint:disable-next-line
export const ManagerSearchInput = styled.input`
  height: 22px;
  width: 450px;
  font-size: 18px;
`;
